// TSS vite/04 §"Endpoint paths". baseURL ya incluye /api/v1.
// Banco de embriones (admin-embryos.md) + picker de disponibles (admin-embryos-available.md).

export const embryoPaths = {
    list:      ()   => 'admin/embryos',
    detail:    (id) => `admin/embryos/${id}`,
    available: ()   => 'admin/embryos/available',
};
